import { FilterOutlineIcon } from '@ikyucom/design-system-icons-react'
import { useAppliedFacetsCount } from '~/features/search/criteria/applied'
import { useOpenCriteria } from '~/navigation'
import { css } from '~/styled-system/css'

export function FilterBox() {
  const onClick = useOpenCriteria('OTHERS')
  const count = useAppliedFacetsCount()
  return (
    <button
      type="button"
      onClick={onClick}
      className={css({ paddingX: '3', display: 'flex', spaceX: '2', placeItems: 'center' })}
    >
      <FilterOutlineIcon
        className={css({
          borderWidth: 'thin',
          borderColor: 'primary',
          height: '[28px]',
          width: '[28px]',
          rounded: 'full',
          padding: '1',
          color: 'primary',
        })}
      />
      <p>絞り込み {count > 0 && `(${count})`}</p>
    </button>
  )
}
